<template>
	<div>
		<v-dialog v-model="dialog_ewaybill" no-click-animation persistent transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader style="display: flex;flex: 1;">E-Invoice Details</v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height>
                    <!-- Generate E-Way bill JSON -->

                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 pt-2>
                            <v-text-field
                                label="IRN Number"
                                v-model="irnNumber"
                                placeholder=" "
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs6 sm6 md6 pt-2 pr-2>
                            <v-text-field
                                label="Ack Number"
                                v-model="ackNumber"
                                placeholder=" "
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs6 sm6 md6 pt-2 pl-2>
                            <v-text-field
                                @click="$parent.fn_openDatePicker('einvoice_ack_date', ackDate)"
                                readonly
                                label="Ack Date"
                                :value="formattedAckDate"
                                placeholder=" "
                                append-icon="arrow_drop_down"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
                    <v-layout row wrap>
                        <v-flex xs6 sm6 md6 center-align style="border-right: 1px #ddd solid;">
                            <v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align>
                            <v-btn small color="blue darken-1" flat @click="fn_saveEinvoiceDetails">Done</v-btn>
                        </v-flex>
                    </v-layout>
		        	<!-- <v-spacer></v-spacer> -->
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>

	export default{
		data(){
			return{
				dialog_ewaybill:false,
                irnNumber:null,
                ackNumber:null,
                ackDate:null,
                formattedAckDate:null,
                isDirectSave:false
			}
		},
		methods:{
            // isDirectSave is using to save invoice directly if eway bill details edited directly from display view for eway bill json
			openDialogWeb: function () {
                if(!this.dialog_ewaybill){
                    this.dialog_ewaybill = true;
                    this.irnNumber = this.$parent.Form.eInvoiceDetails.irnNumber;
                    this.ackNumber = this.$parent.Form.eInvoiceDetails.ackNumber;
                    this.ackDate = this.$parent.Form.eInvoiceDetails.ackDate;
                    this.formattedAckDate = this.ackDate ? this.$moment(this.ackDate).format('DD-MMM-YYYY') : null;
                    this.isDirectSave = false;
                }
			},
			closeDialogWeb: function () {
				this.dialog_ewaybill = false;
                if(this.$route.query.section_id && this.$route.query.section_id == 'einvoice_details'){
                    if(this.isDirectSave){
                        // saving invoice directly
                        this.$parent.fn_checkValidations();
                    }
                    else{
                        setTimeout(() => {
                            // going back directly if user goes back without saving
                            this.$parent.fn_goBack();
                        }, 300);
                    }
			    }
			},
            fn_updateDate: function(value){
                this.ackDate = value;
                this.formattedAckDate = this.ackDate ?  this.$moment(this.ackDate).format('DD-MMM-YYYY') : null;
            },
            fn_saveEinvoiceDetails: function(){
                this.$route.query.section_id && this.$route.query.section_id == 'einvoice_details' ? this.isDirectSave = true : '';
                this.$parent.Form.eInvoiceDetails.irnNumber = this.irnNumber;
                this.$parent.Form.eInvoiceDetails.ackNumber = this.ackNumber;
                this.$parent.Form.eInvoiceDetails.ackDate = this.ackDate;
                this.$parent.fn_closeDialog();
            },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/sale/dialogs/dialog_einvoice_details.vue